import { ActionReducer, MetaReducer } from '@ngrx/store';
import { AppState } from '.';
import { LocalStorageService } from '../services/local-storage.service';

export function localStorageMetaReducer(
  localStorageService: LocalStorageService
): MetaReducer<AppState> {
  return (reducer: ActionReducer<AppState>) => {
    let hydrated = false;
    return (state, action) => {
      const nextState = reducer(state, action);
      if (!hydrated) {
        hydrated = true;
        const hydratedUi = { ...nextState.ui, ...localStorageService.readUiState() };
        const hydratedState = { ...nextState, ui: hydratedUi };
        localStorageService.writeUiState(hydratedState.ui);
        return hydratedState;
      }
      localStorageService.writeUiState(nextState.ui);
      return nextState;
    };
  };
}
